import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {EmployeeTimeCardReportData} from "./employee-time-card-report.data";

@Injectable()
export class EmployeeTimeCardReportModel extends ReportModel<EmployeeTimeCardReportData> {
    constructor(injector: Injector) {
        super(injector, EmployeeTimeCardReportData);
    }
}
